import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import RoadiesShell from './RoadiesShell';
import { fetchRoadiesLeaderboard } from './api';

// leaderboard.php: top finishers for this session/organization, ranked by score then time.
export default function RoadiesLeaderboard() {
  const session = useSelector((s) => s.roadies.session);
  const [rows, setRows] = useState(null);
  const [me, setMe] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!session) return;
    let alive = true;
    fetchRoadiesLeaderboard(session)
      .then((res) => {
        if (!alive) return;
        const data = res.data || {};
        setRows(Array.isArray(data) ? data : data.top || []);
        setMe(data.me || null);
      })
      .catch((e) => alive && setError(e?.response?.data?.message || e.message || 'Could not load leaderboard'));
    return () => {
      alive = false;
    };
  }, [session]);

  return (
    <RoadiesShell bg="phill.jpg" bgMob="phill-mob.jpg" className="rd-leaderboard">
      <div className="rd-gamehead"><h2 className="rd-title">Leaderboard</h2></div>
      <div className="rd-board">
        {error && <p>{error}</p>}
        {!error && !rows && <p>Loading…</p>}
        {rows && (
          <table>
            <thead>
              <tr><th>Rank</th><th>Name</th><th>Score</th><th>Time</th></tr>
            </thead>
            <tbody>
              {rows.length === 0 && (
                <tr><td colSpan={4} style={{ textAlign: 'center' }}>No finishers yet</td></tr>
              )}
              {rows.map((r) => (
                <tr key={r.userId || r.rank} className={me && r.userId === me.userId ? 'me' : ''}>
                  <td>{r.rank}</td>
                  <td>{r.name}</td>
                  <td>{r.points}</td>
                  <td>{r.time}</td>
                </tr>
              ))}
              {me && (
                <tr className="me">
                  <td>{me.rank}</td>
                  <td>{me.name} (You)</td>
                  <td>{me.points}</td>
                  <td>{me.time}</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </RoadiesShell>
  );
}
